import { render, staticRenderFns } from "./TransactionConfigSelector.vue?vue&type=template&id=09d59802&scoped=true&"
import script from "./TransactionConfigSelector.vue?vue&type=script&lang=js&"
export * from "./TransactionConfigSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d59802",
  null
  
)

export default component.exports